/**
 * Require a delivery-date selection (DATO) before Add to cart.  [v7]
 *
 * DATO pre-seeds today into its hidden fields, so we validate the VISIBLE input
 * (empty until a real pick). On failure we highlight DATO's white input box and
 * show a full-width inline message below the whole datepicker block.
 * Which days are selectable stays DATO's job (Available Days).
 *
 * Placement: assets/require-delivery-date.js, loaded in sections/main-product.liquid:
 *   <script src="{{ 'require-delivery-date.js' | asset_url }}" defer="defer"></script>
 */
(function () {
  var TAG = '[delivery-date guard]';
  var MESSAGE = 'Please pick a delivery date before adding to cart.';

  function getVisibleDateInput() {
    var anchor = document.querySelector('input[id*="datepick" i], input[id^="dp_"]');
    var node = anchor ? anchor.parentElement : null;
    for (var up = 0; up < 4 && node; up++) {
      var near = Array.prototype.slice
        .call(node.querySelectorAll('input'))
        .filter(function (el) { return el.type !== 'hidden' && el.offsetParent; })[0];
      if (near) return near;
      node = node.parentElement;
    }
    return Array.prototype.slice
      .call(document.querySelectorAll('input[placeholder]'))
      .filter(function (el) {
        return el.type !== 'hidden' && el.offsetParent && /YYYY|DD|MM/i.test(el.placeholder || '');
      })[0] || null;
  }

  // The white bordered input box to highlight (the ~260px flex box).
  function getOuterBox() {
    var input = getVisibleDateInput();
    return (input && (input.closest('[id^="dp_datepikrDiv"]') || input.parentElement)) ||
           document.getElementById('datepickerapp') ||
           null;
  }

  function dateMissing() {
    var input = getVisibleDateInput();
    if (!input) { console.warn(TAG, 'date field NOT found -> allowing (fail open)'); return false; }
    return !String(input.value).trim();
  }

  function getMessageEl() {
    var existing = document.getElementById('delivery-date-error');
    if (existing) return existing;

    // Insert the message after the WHOLE datepicker block (full width),
    // not beside the narrow white box, so it doesn't get flex-squished.
    var input = getVisibleDateInput();
    var anchor = document.getElementById('datepickerapp') ||
                 (input && input.closest('[id^="dp_mainDP"]')) ||
                 getOuterBox();
    if (!anchor) return null;

    var el = document.createElement('div');
    el.id = 'delivery-date-error';
    el.setAttribute('role', 'alert');
    el.textContent = MESSAGE;
    el.style.cssText =
      'display:none; width:100%; flex-basis:100%; margin-top:.5rem; ' +
      'color:#b00020; font-size:1.5rem; font-weight:700; font-style:italic;';
    anchor.parentNode.insertBefore(el, anchor.nextSibling);
    return el;
  }

  function showError() {
    var msg = getMessageEl();
    if (msg) msg.style.display = 'block';
    var box = getOuterBox();
    if (box) {
      box.style.outline = '3px solid #b00020';
      box.style.outlineOffset = '2px';
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var input = getVisibleDateInput();
    if (input) {
      input.addEventListener('change', clearError, { once: true });
      input.addEventListener('input', clearError, { once: true });
    }
  }

  function clearError() {
    var msg = document.getElementById('delivery-date-error');
    if (msg) msg.style.display = 'none';
    var box = getOuterBox();
    if (box) box.style.outline = '';
  }

  function guard(e) {
    if (dateMissing()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      showError();
    } else {
      clearError();
    }
  }

  var addBtns = Array.prototype.slice.call(
    document.querySelectorAll('button[name="add"], input[name="add"], [name="add"]')
  );
  var boundForms = [];
  addBtns.forEach(function (btn) {
    btn.addEventListener('click', guard, true);
    var f = btn.closest('form');
    if (f && boundForms.indexOf(f) === -1) {
      boundForms.push(f);
      f.addEventListener('submit', guard, true);
    }
  });
  if (!boundForms.length) {
    var f = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (f) { f.addEventListener('submit', guard, true); boundForms.push(f); }
  }

  console.log(TAG, 'v7 loaded. add buttons:', addBtns.length, '| forms bound:', boundForms.length);
})();